import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasUploadMetaData from './aidas-upload-meta-data';
import AidasUploadMetaDataDetail from './aidas-upload-meta-data-detail';
import AidasUploadMetaDataUpdate from './aidas-upload-meta-data-update';
import AidasUploadMetaDataDeleteDialog from './aidas-upload-meta-data-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasUploadMetaDataUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasUploadMetaDataUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasUploadMetaDataDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasUploadMetaData} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasUploadMetaDataDeleteDialog} />
  </>
);

export default Routes;
